<script>
    // ?id=9921&dnApp=1&dnAppVersion=6.5.5
    // ?id=9921&dnApp=1&dnAppVersion=6.5.5&darkMode=1
    import { onMount } from "svelte";
    import {
    baseUrl,
    getUrlVars,
    inIframe,
    handleMargins,
    handleDarkModeSettings,
    useDarkMode,
    isForcedColorMode 

    } from "../../scripts/loadExternalData";

    import { initTracking } from "../../scripts/tracker";
    import maplibregl from 'maplibre-gl';
    import 'maplibre-gl/dist/maplibre-gl.css';
    //import { point, polygon,multiPolygon,centroid } from "@turf/turf?module";
    import * as turf from '@turf/turf';
    import moment from 'moment';
    import 'moment/locale/sv';
    import Switch  from "./components/Switch.svelte";
   

    let map;
    let mapBG;
    let mapContainer;
    let mapContainerBG;

    
    export const trackevents = initTracking();
  

  
    export const state = {

      header: "Varningar",
      introduction: "Lorem lipsum",
      source: "Källa:SMHI",
      mapData:'',
      darkMode:false,
      appDarkMode:false,
      varningarAlla:[],
      varningarText:[],
      varningarGul:[],
      varningarOrange:[],
      varningarRod:[],
      varningarMess:[],
      chunkingListStart:[],
      chunkingListEnd:[],
      chunkingNumber:20,
      chunking:{},
      mapData:[],
      allMarkers:[],
      hideYellowsToggle:true,
      wdate:'',
      wtime:'',
      showContent:'Varningar och meddelanden',
      messageColors:'#cccccc,#ffffff',
      printtime:'',
      futureEvents:'Ja',
      showFutureWarnings:false,
      showFutureWarningsType:'alla',
      showDaysWarnings:true, 
      onWeb:false,
      mFilter:'inget filter',
      mFilterType:'SNOW_MOBILE',
      darkModeSettings:'no_settings',
      startPoint:'undefined',
      legendOnOff: false
    }

    let myRenderDarkMode = getUrlVars().darkMode === '1';
    let myRenderForcedColorMode = false;

    state.chunking = {
      'Gul':{
        'chunk':false,
        'antal':0,
        'text':'Gula varningar'
      },
      'Orange':{
        'chunk':false,
        'antal':0,
        'text':'Oranga varningar'
      },
      'Rod':{
        'chunk':false,
        'antal':0,
        'text':'Röda varningar'
      },
      'Mess':{
        'chunk':false,
        'antal':0,
        'text':'Meddelanden'
      },
    }

    state.chunkingtrans = {
      'YELLOW':{
        'text':'Gul'
      },
      'ORANGE':{
        'text':'Orange'
      },
      'RED':{
        'text':'Rod'
      },
      'MESSAGE':{
        'text':'Mess'
      },
    }

    let mapcolors = {
      'Gul':{
        'area':'#fff45e',
        'line':'#fdc226',
      },
      'Orange':{
        'area':'#f58e04',
        'line':'#bf5905',
      },
      'Röd':{
        'area':'#fa0715',
        'line':'#980806',
      },
      'Meddelande':{
        'area':'#fff',
        'line':'#333',
      },
    }

    let ShowWaringTypes = {
      'Gul':false,
      'Orange':false,
      'Röd':false,
      'Meddelande':false
    }


    //console.log(state.chunking[state.chunkingtrans['ORANGE'].text].text);
    
    let svlanguage = {
            touch: "Anv\u00e4nd tv\u00e5 fingrar f\u00f6r att flytta kartan",
            scroll: "Anv\u00e4nd ctrl + rulla f\u00f6r att zooma kartan",
            scrollMac: "Anv\u00e4nd \u2318 + rulla f\u00f6r att zooma p\u00e5 kartan"
        };


    let onOff = {};
    let onOffChunking = {};
  
    let legendOnOff = false;

    let haveADate = true;

      for (let i = 0; i < 300; i++) {

        onOff['warning'+i] = false;
      
      }

      for (let i = 0; i < 300; i++) {

        onOffChunking['chunking'+i] = true;

      }

    onMount(async() => {


      //console.log('Onmount');
 
      burstPostRatio();
   

      trackevents.enterIntoView('Visible', 'SMHIKarta OneShot', 'SMHIKartat');
      //window.addEventListener("resize", () => postRatio());
  
      if(!inIframe()) {
        document.getElementsByTagName('body')[0].style.overflow = 'auto';
        document.getElementsByTagName('body')[0].style.margin = '0';
       
      } else {
        if(window.innerWidth <= 620) {
          document.getElementsByTagName('body')[0].style.margin = '0';
        }

      }


      if(document.getElementsByTagName('body')[0].offsetWidth <= 479) {
        state.onWeb = false;
      } else {
        state.onWeb = true;
      }


        //console.log(state.onWeb);

        //console.log(document.getElementsByTagName('body')[0]);
/*
      if(getUrlVars().darkMode) {
        state.appDarkMode = getUrlVars().darkMode === '1';
        if(getUrlVars().darkMode === '1'){
          document.getElementsByTagName('body')[0].style.paddingBottom = '8px';
          document.getElementsByTagName('body')[0].style.backgroundColor = '#1f1f1f';
        }
      }
      //console.log(getUrlVars().dnApp);
      if(getUrlVars().dnApp) {

        if(getUrlVars().dnApp === '1'){
          document.getElementsByTagName('body')[0].classList.add("inapp");
          document.getElementsByTagName('html')[0].classList.add("inapp");
        }

      }
*/
      await fetchPatronData();

      legendOnOff = state.legendOnOff;

      if( typeof state.source === "undefined" ||  state.source === null || state.source === '' ) { 

        state.source = 'Källa: SMHI';

      }

      mapcolors.Meddelande.area = state.messageColors.split(",")[0];
      mapcolors.Meddelande.line = state.messageColors.split(",")[1];

      if(state.showContent == 'Varningar och meddelanden') {

        ShowWaringTypes.Gul = true;
        ShowWaringTypes.Orange = true;
        ShowWaringTypes.Röd = true;
        ShowWaringTypes.Meddelande = true;
      }
      if(state.showContent == 'Bara varningar') {
        
        ShowWaringTypes.Gul = true;
        ShowWaringTypes.Orange = true;
        ShowWaringTypes.Röd = true;
        ShowWaringTypes.Meddelande = false;
      } 
      if(state.showContent == 'Bara meddelanden') {
        
        ShowWaringTypes.Gul = false;
        ShowWaringTypes.Orange = false;
        ShowWaringTypes.Röd = false;
        ShowWaringTypes.Meddelande = true;
      }       
   
      if(state.futureEvents == 'Ja') {
    
      state.showFutureWarnings = true;
      state.showDaysWarnings  = true;
      state.showFutureWarningsType = 'alla';

      } else if (state.futureEvents == 'Nej') {

        state.showFutureWarnings = false;
        state.showDaysWarnings  = true;
        state.showFutureWarningsType = 'days';
      
      
    } else if (state.futureEvents == 'Visa Alla') {
          
        state.showFutureWarnings = true;
        state.showDaysWarnings  = true;
        state.showFutureWarningsType = 'alla';

      } else if (state.futureEvents == 'Bara framtida') {

        state.showFutureWarnings = true;
        state.showDaysWarnings  = false;
        state.showFutureWarningsType = 'future';
      
      } else if (state.futureEvents == 'Bara dagens') {

        state.showFutureWarnings = false;
        state.showDaysWarnings  = true;
        state.showFutureWarningsType = 'days';
      
      }

     
      if( typeof state.wdate !== "undefined" &&  state.wdate !== null && state.wdate !== '' && state.wdate.length > 5 && state.wdate !== 'Ange ett datum' ) { 


        let input = state.wdate;

        // Ta bort alla mellanslag
        input = input.replace(/\s/g, '');

        // Reguljärt uttryck för att extrahera datumdelen (YYYY-MM-DD)
        let datePattern = /^(\d{4}-\d{2}-\d{2})/;
        let dateMatch = input.match(datePattern);

        let A = null;
        let B = null;

        if (dateMatch) {
            A = dateMatch[1]; // Datumdelen
            // Reguljärt uttryck för att extrahera tidsdelen (HH:MM) efter datumdelen
            let timePattern = /\d{4}-\d{2}-\d{2}(\d{2}:\d{2})$/;
            let timeMatch = input.match(timePattern);

            if (timeMatch) {
                B = timeMatch[1]; // Tidsdelen om den finns
            }
        }

        // console.log("Datum (A):", A);
        // console.log("Tid (B):", B);

        state.wdate = A ;

        if(B) {
          state.wtime = B;
        }

        haveADate = true; 

        await fetchMapData();

        //console.log('SMHI contacted');

        loadMap();


        state.printtime = moment(new Date(state.wdate ));
        state.printtime = state.printtime.format('dddd DD MMMM YYYY'); 


      } else {

        haveADate = false; 
        //console.log(haveADate);
      }

      // handle darkmode
      handleDarkModeSettings(state.appDarkMode,state.darkMode,state.darkModeSettings);
      
      myRenderDarkMode = useDarkMode();
      myRenderForcedColorMode = isForcedColorMode();

      if ( myRenderDarkMode ) {
        document.getElementsByTagName("body")[0].classList.add("body__dark-mode");
      } else {
        document.getElementsByTagName("body")[0].classList.add("body__light-mode");
      } 

      burstPostRatio();

    });


    async function fetchMapData() {

      //console.log('fetchMapData');

        //await fetch(`data/${state.wdate}.json`)
        //await fetch(`https://opendata-download-warnings.smhi.se/ibww/api/version/1/warning.json`)
        await fetch(`https://storage.googleapis.com/smhidata/${state.wdate}.json?cb=${crypto.randomUUID()}`)
          .then(r => r.json())
          .then(data => {
            state.mapData = data;
          });

    }





    async function fetchPatronData() {

      //console.log('fetchPatronData');

    await fetch(`${baseUrl}/fields/${getUrlVars().id}`)
        .then((data) => data.json())
        .then(({ fields, title }) => {
          
          for (let name in state) {
            if(!fields.find(({ key }) => key === name)) continue;
  
            state[name] = fields.find(({ key }) => key === name).value;
          }
  
          if(getUrlVars().darkMode) {
            state.appDarkMode = getUrlVars().darkMode === '1';
          }
  

        });
}








    function burstPostRatio(){

      //console.log('burstPostRatio');

        postRatio();

        setTimeout(function () {
        postRatio();
        }, 50);
        setTimeout(function () {
        postRatio();
        }, 100);
        setTimeout(function () {
        postRatio();
        }, 300);
        setTimeout(function () {
        postRatio();
        }, 500);
        setTimeout(function () {
        postRatio();
        }, 1000);
        setTimeout(function () {
        postRatio();
        }, 3500);

    }






    function postRatio() {
        const containerElement = document.getElementsByTagName("body")[0];
    
        window.parent.postMessage(
            {
            ratio: containerElement.offsetHeight / window.innerWidth,
            location: window.location.href,
            },
            "*"
        );
    }



function loadMap(){

  //console.log('loadMap');

  let zoomV = 3.0;

  const containerElement = document.getElementsByTagName("body")[0];

  if(containerElement.offsetWidth > 400 ){

    zoomV = 3.8;

  }
  let bounds = new maplibregl.LngLatBounds([1.168987465248507,54], [35.47400936186565, 70.0])
  //console.log('start Loading map');

  mapBG = new maplibregl.Map({
        container: mapContainerBG,
        style:'../assets/json/maps/DN_Map.json',
        center: [14.649270094097576,62.753180265754224],
        zoom: zoomV,
        minZoom:zoomV,
        maxZoom:13,
        maxBounds:bounds
        });



    map = new maplibregl.Map({
        container: mapContainer,
        style:{version: 8,id:'1',name:'tom',sources: {},layers: []},
        center: [14.649270094097576,62.753180265754224],
        zoom: zoomV,
        cooperativeGestures: !state.onWeb,
        minZoom:zoomV,
        maxZoom:13,
        maxBounds:bounds
        });


        map.addControl(new maplibregl.NavigationControl({
          showCompass: false
        }),'bottom-right');
  
      syncMaps(map, mapBG);
    //console.log(map);
    //console.log('wait');
    map.on('load', function () {

      //console.log('maploaded');


          iterateWarnings();

          if(!state.onWeb){changeTexts();}

          zoomToNumber(state.startPoint);
          burstPostRatio();

    });

    map.on("click", function (e) {

      mapClicked( e );

    });
}

function filterWarnings(mFilter,mFilterType,current) {

  // funktionen får in en händelse/varning (current)  och functionen skall avgöra om den skall filtreras bort eller visas true / false

  //  mFilterType = filtret angivet i patron t.ex WIND_SEA
  //  mFilter = hur filtrera 'Filtrera Bort' 'Visa Endast'
  // current typen av händelse vi skall testa

  let list = ['THUNDER','WIND','WIND_MOUNTAINS','WIND_MOUNTAINS_SNOW','STRONG_COOLING','SNOW','WIND_SNOW','BLACK_ICE','RAIN','FIRE','HIGH_TEMPERATURES','WIND_SEA','ICE_ACCRETION','LOW_SEA_LEVEL','HIGH_SEALEVEL','WATER_SHORTAGE','HIGH_FLOW','FLOODING'];
  
  let landbasedList = ['THUNDER','WIND','WIND_MOUNTAINS','WIND_MOUNTAINS_SNOW','STRONG_COOLING','SNOW','WIND_SNOW','BLACK_ICE','RAIN','FIRE','HIGH_TEMPERATURES','WATER_SHORTAGE','HIGH_FLOW','FLOODING',,'LOW_SEA_LEVEL','HIGH_SEALEVEL'];
  
  let seabasedList = ['WIND_SEA','ICE_ACCRETION'];

  if(mFilter != 'Inget Filter' ){

    if(mFilter == 'Filtrera Bort' ){

      if(mFilterType.toUpperCase() === 'LAND_BASED'){
        list = seabasedList;
      } else {
        list = list.filter(e => e !== mFilterType.toUpperCase());
      }
      
    }

    if(mFilter == 'Visa Endast' ){

      if(mFilterType.toUpperCase() === 'LAND_BASED'){
        list = landbasedList;
      } else {
        list = [mFilterType.toUpperCase()];
      }

      
    }

    //console.log('TEST');
    //console.log(mFilterType.toUpperCase());
  }

  let returner = false;

  for (let j = 0; j < list.length; j++) {

    //console.log(current);

    if(current == list[j]){
      returner = true;
    }
  
  }

  return returner;

}
function iterateWarnings() {


      for (let j = 0; j < state.mapData.length; j++) {

        if( filterWarnings(state.mFilter, state.mFilterType , state.mapData[j].event.code) ) {

            let varningareas = state.mapData[j].warningAreas;

            for (let i = 0; i < varningareas.length; i++) {

                if(ShowWaringTypes[varningareas[i].warningLevel.sv]){

                    

                   
                    if( typeof varningareas[i].areaName === "undefined" ||  typeof varningareas[i].areaName=== null) {

                      console.log(varningareas[i]);

                      varningareas[i].areaName = {};
                      varningareas[i].areaName.sv = varningareas[i].affectedAreas[0].sv;

                    }
                    console.log(varningareas[i].approximateStart +'    ' +varningareas[i].areaName.sv);
                        
                    let vobj = {};
                    vobj.data = varningareas[i];

                    moment.locale('sv');
                    let stime = moment(new Date(varningareas[i].approximateStart));
                    let etime = moment(new Date(varningareas[i].approximateEnd));
                    let utime = moment(new Date(varningareas[i].published));



                    vobj.sdate = stime.format('dddd DD MMMM') +' kl. ' + stime.format('HH.mm'); 
                    vobj.edate = etime.format('dddd DD MMMM') +' kl. ' + etime.format('HH.mm'); 
                    vobj.udate = utime.format('dddd DD MMMM') +' kl. ' + utime.format('HH.mm'); 
                    vobj.id = varningareas[i].id;
                    vobj.source = 'VID'+varningareas[i].id;
                    vobj.north = getTheNorthPoint(varningareas[i]);
                    vobj.wmess = varningareas[i].warningLevel.sv;

                    /* console.log(vobj.north );
                    console.log(vobj.id +' ' +vobj.source);
                    console.log(vobj.wmess);
                    console.log(vobj.data.areaName.sv);
                    console.log('  ');
                     console.log('  '); */
                    
                    if(varningareas[i].warningLevel.sv == 'Gul' || varningareas[i].warningLevel.sv == 'Orange' || varningareas[i].warningLevel.sv == 'Röd'){

                    vobj.wmess = varningareas[i].warningLevel.sv +' varning';
                    }


                    if( typeof varningareas[i].approximateEnd === "undefined" ||  typeof varningareas[i].approximateEnd === null ){
                    vobj.edate = 'tills vidare';
                    }

                    // kolla om händelsen ligger i framtiden
                    if( (state.showFutureWarningsType === 'alla') || 
                    (state.showFutureWarningsType === 'days' && isDateToday(state.wdate,state.wtime,varningareas[i].approximateStart,varningareas[i].approximateEnd)) || 
                    (state.showFutureWarningsType === 'future' && !isDateToday(state.wdate,state.wtime,varningareas[i].approximateStart,varningareas[i].approximateEnd))  ) {
                      
                      //state.varningarAlla.push(vobj);

                      if(varningareas[i].warningLevel.sv == 'Gul' ){
                        state.varningarGul.push(vobj);
                      }
                      else if(varningareas[i].warningLevel.sv == 'Orange' ){
                        state.varningarOrange.push(vobj);
                      }
                      else if(varningareas[i].warningLevel.sv == 'Röd' ){
                        state.varningarRod.push(vobj);
                      }
                      else {
                        state.varningarMess.push(vobj);
                      }

                    };
                
                    
                }
            }
        }    
      }    


  //sortera



  //state.varningarAlla = state.varningarAlla.slice(0);

  //state.varningarAlla.sort(function(a,b) {return a.north - b.north;});
  //state.varningarAlla.reverse();

  state.varningarGul.sort(function(a,b) {return a.north - b.north;});
  state.varningarGul.reverse();

  state.varningarOrange.sort(function(a,b) {return a.north - b.north;});
  state.varningarOrange.reverse();


  state.varningarRod.sort(function(a,b) {return a.north - b.north;});
  state.varningarRod.reverse();


  state.varningarMess.sort(function(a,b) {return a.north - b.north;});
  state.varningarMess.reverse();


  state.varningarAlla = state.varningarRod.concat(state.varningarOrange, state.varningarGul, state.varningarMess); 

  state.varningarText = state.varningarAlla;

  let varningareas = state.varningarAlla;
  
//console.log(state.varningarText);





  if(state.varningarGul.length > state.chunkingNumber){

      state.chunking.Gul.chunk = true;

    }

  if(state.varningarOrange.length > state.chunkingNumber){

    state.chunking.Orange.chunk = true;

    }

  if(state.varningarRod.length > state.chunkingNumber){

    state.chunking.Rod.chunk = true;

    }

  if(state.varningarMess.length > state.chunkingNumber){

    state.chunking.Mess.chunk = true;

    }

    state.chunking.Gul.antal    = state.varningarGul.length;
    state.chunking.Orange.antal = state.varningarOrange.length;
    state.chunking.Rod.antal    = state.varningarRod.length;
    state.chunking.Mess.antal   = state.varningarMess.length;
  

  for (let i = 0; i < varningareas.length; i++) {
    state.chunkingListStart[i] = 0;
    state.chunkingListEnd[i] = 0;
  }

  if(state.chunking.Rod.chunk){
    state.chunkingListStart[0] = 's';
    state.chunkingListEnd[state.chunking.Rod.antal-1] = 'e';
  }

  if(state.chunking.Orange.chunk){
    state.chunkingListStart[(state.chunking.Rod.antal)] = 's';
    state.chunkingListEnd[(state.chunking.Rod.antal)+(state.chunking.Orange.antal)-1] = 'e';
  }

  if(state.chunking.Gul.chunk){
    state.chunkingListStart[(state.chunking.Rod.antal)+(state.chunking.Orange.antal)] = 's';
    state.chunkingListEnd[(state.chunking.Rod.antal)+(state.chunking.Orange.antal)+(state.chunking.Gul.antal)-1] = 'e';
  }

  if(state.chunking.Mess.chunk){
    state.chunkingListStart[(state.chunking.Rod.antal)+(state.chunking.Orange.antal)+(state.chunking.Gul.antal)] = 's';
    state.chunkingListEnd[(state.chunking.Rod.antal)+(state.chunking.Orange.antal)+(state.chunking.Gul.antal)+(state.chunking.Mess.antal)-1] = 'e';
  }

//console.log(state.chunkingListStart);
//console.log(state.chunkingListEnd);
//console.log(state.chunking);
          
          

          let number = varningareas.length -1;
          
          for (let i = varningareas.length -1; i > -1; i--) {  

            map.addSource('VID'+varningareas[i].data.id, {'type': 'geojson','data':varningareas[i].data.area});

            if (varningareas[i].data.area.type != 'FeatureCollection') {

              addPolygons(varningareas[i].data.id,varningareas[i].data.warningLevel.sv,varningareas[i].data.area.geometry,number);


              } else {

                if(varningareas[i].data.area.features[0].geometry.type == 'LineString'){

                  map.addLayer({
                  'id': 'outline'+varningareas[i].data.id,
                  'type': 'line',
                  'source': 'VID'+varningareas[i].data.id,
                  'layout': {},
                  'paint': {
                  'line-color': mapcolors[varningareas[i].data.warningLevel.sv].area,
                  'line-width': 7,
                  'line-opacity': 1,
                  }
                  });

                  let warnlevel = varningareas[i].data.warningLevel.sv;

                  createMarker(turf.center(turf.points(varningareas[i].data.area.features[0].geometry.coordinates)),warnlevel,number);

                } else { 


                  addPolygons(varningareas[i].data.id,varningareas[i].data.warningLevel.sv,varningareas[i].data.area.features[0].geometry,number);

                }

              }

              number = number -1;
              
          }
}




function isDateToday(widgetDateString,widgetTimeString,warningDateString,warningDateEndString) {

  moment.locale('sv');

  let witime = moment(new Date(widgetDateString));
  let watime = moment(new Date(warningDateString));
  let waendtime = moment(new Date(warningDateEndString));

  //kolla om vi anfet tid
  if( widgetTimeString === "") {


    // gämför bara dagar
   
    witime  = witime.format('YYYY-MM-DD'); 
    watime  =  watime.format('YYYY-MM-DD'); 


    var widget = new Date(witime);
    var wstart = new Date(watime);

    /*
    console.log(warningDateString);
    console.log(warningDateEndString);

    console.log(witime);
    console.log(watime);

    console.log(wstart);
    console.log(widget);

    console.log('______');
    */


    if (wstart > widget ){
      console.log('Varningen börjar i framtiden nästa dag');
      //console.log('Falsk');
      //console.log('-------');
      return false;

    } 
    //console.log('-------');
    return true; 


  } else {

    // jämför med tid också

    // console.log('jämför med tid också');


    witime = moment(new Date(widgetDateString +' ' +widgetTimeString));

    //witime = moment(new Date('2024-08-30 12:00'));

    witime  = witime.format('YYYY-MM-DD HH:mm'); 
    watime  =  watime.format('YYYY-MM-DD HH:mm'); 
    waendtime  =  waendtime.format('YYYY-MM-DD HH:mm'); 

    /*
    console.log('nu är klockan ' + witime);
    console.log('varning startar ' + watime);
    console.log('varning slutar ' + waendtime);
    */

    var widget = new Date(witime);
    var wstart = new Date(watime);
    var wsend = new Date(waendtime);

    if( (wstart > widget) ) {

      // console.log('visa ej - starten ligger i framtiden');
      // console.log('-------');

      return false;

    } else if(wsend < widget) {

      // console.log('visa ej - samma dag men redan passerad tidsmässigt');
      // console.log('-------');

      return false;

    
    } else {
      // console.log('visa - varingen är aktuell');
      // console.log('-------');
      return true;

    }


  }
}


function addPolygons(id,level,geo,number) {


  map.addLayer({
                'id': 'area'+id,
                'type': 'fill',
                'source': 'VID'+id,
                'layout': {},
                'paint': {
                'fill-color': mapcolors[level].area,
                'fill-opacity': 0.7,
                }
                });


                map.addLayer({
                  'id': 'outline'+id,
                  'type': 'line',
                  'source': 'VID'+id,
                  'layout': {},
                  'paint': {
                  'line-color': mapcolors[level].line,
                  'line-width': 1
                  }
                  });

                  let multiPoly = '';
                  let warnlevel = level;

              

                if(geo.type == "MultiPolygon" ){

                      multiPoly = turf.multiPolygon(geo.coordinates);

                      let multilist = geo.coordinates;

                      for (let i = 0; i < multilist.length; i++) {
                        try {
                        createMarker(turf.centerOfMass(turf.polygon(multilist[i])),warnlevel,number);
                        } catch( e ) {
                            //  Block of code to handle errors

                            //console.log(e);
                           // console.log(id + ' ' +level +' ' +number);
                            //console.log(geo);
                        }
                      }

                } else {
                 try { 
//createMarker(turf.centerOfMass(turf.polygon(geo.coordinates)),warnlevel,number);
                  if(geo.type == "Polygon"){
                    createMarker(turf.centerOfMass(turf.polygon(geo.coordinates)),warnlevel,number);
                  }
                  if(geo.type == "LineString"){
                    createMarker(turf.centerOfMass(turf.lineString(geo.coordinates)),warnlevel,number);
                  }
                  
                 } catch( e ) {
                      //  Block of code to handle errors
                      //console.log(e);
                      //console.log('Failer');
                      //console.log(id + ' ' +level);
                      //console.log(id + ' ' +level +' ' +number);
                      //console.log(geo);
                 }

                }
}

function createMarker(thepoint,warnlevel,number) {

  var el = document.createElement('div');
              el.className = 'marker ' +warnlevel;
  
              el.style.width = '15px';
              el.style.height = '15px';
              el.style.backgroundColor = mapcolors[warnlevel].area;
              el.style.borderColor = mapcolors[warnlevel].line;
              el.innerText = number+1;

              // add marker to map
              let tempm = new maplibregl.Marker(el)
              .setLngLat(thepoint.geometry.coordinates)
              .addTo(map);

              state.allMarkers.push(tempm);
}

function getTheNorthPoint(varningareas) {

    //console.log(varningareas);

  let mostNorth = 0;

  let interator  = [];

  let gtype = '';

  if (varningareas.area.type == 'FeatureCollection') {


    if(varningareas.area.features[0].geometry.coordinates.length < 5 ){
      interator = varningareas.area.features[0].geometry.coordinates[0];
    } else {
      interator = varningareas.area.features[0].geometry.coordinates;
    }

    gtype = varningareas.area.features[0].type;
     

  } else {

    interator = varningareas.area.geometry.coordinates;


    if(varningareas.area.geometry.coordinates.length < 5 ){
      interator = varningareas.area.geometry.coordinates[0];
    } else {
      interator = varningareas.area.geometry.coordinates;
    }


    gtype = varningareas.area.geometry.type;
  }


  if(gtype == 'MultiPolygon') {

      for (let j = 0; j < interator.length; j++) {
        for (let i = 0; i < interator[j][0].length; i++) {
          if(mostNorth < interator[j][0][i][1]){
            mostNorth = interator[j][0][i][1];
          }
        }
      }

  } else {

        for (let j = 0; j < interator.length; j++) {
       
            if(mostNorth < interator[j][1]){
              mostNorth = interator[j][1];
            }
        }
  }  


  return mostNorth; 


}


function showChunks(todo, color) {
  //console.log('showchunks');
  //console.log(todo);
  //console.log(color);

  if(todo){
   
    Array.from(document.querySelectorAll('.CH-'+color)).forEach(function(box) {
     box.style.display = 'none';
     //console.log(box);
    });


  } else {
    Array.from(document.querySelectorAll('.CH-'+color)).forEach(function(box) {
     box.style.display = 'block';
     //console.log(box);
    });

  }

  burstPostRatio();

}

function zoomToArea(feat) {

    //console.log('testing');

    if (feat.type == 'FeatureCollection') {

        feat = feat.features[0];

    }




    // zoom
    let coordinates = feat.geometry.coordinates[0][0];

    if (feat.geometry.type == "MultiPolygon") {
      // if multy polygon zomm to the bigest polygon

      let numbers = [];

      for (let i = 0; i < feat.geometry.coordinates.length; i++) {
        numbers[i] = feat.geometry.coordinates[i][0].length;
      }

      // this is the bigest
      let indexOfMaxValue = numbers.indexOf(Math.max(...numbers));

      coordinates = feat.geometry.coordinates[indexOfMaxValue][0];

      //console.log('MultiPolygon');

    } else if (feat.geometry.type == "LineString") {

        coordinates = feat.geometry.coordinates;

        //console.log('LineString');
        
    } else {

      //console.log('Polygon');

      coordinates = feat.geometry.coordinates[0];

    }


    //console.log(coordinates);

    const bounds = new maplibregl.LngLatBounds(coordinates[0], coordinates[0]);

    // Extend the 'LngLatBounds' to include every coordinate in the bounds result.
    for (const coord of coordinates) {
      bounds.extend(coord);
    }

    map.fitBounds(bounds, {
      padding: 100,
      linear: false,
      duration: 1000,
    });

    setTimeout(function () {
      burstPostRatio();
        }, 1200);
   

  }



function mapClicked( theclickevent ) {  

  

      const features = map.queryRenderedFeatures(theclickevent.point);

      //console.log(features);

      for (const feat of features) {
        if ( feat.source.startsWith("VID") ) {
          for (const varning of state.varningarAlla) {

            if (feat.source === varning.source) {
              // zoom
              zoomToArea(varning.data.area);
              break;
            }
          }
        }
      }

 
}


function zoomToNumber(num) {
  let i = 0;
  if(typeof num !== 'undefined' && num !== null && num !== '' && num !== ' '){

    for (const varning of state.varningarAlla) {

      if ((num-1) === i) {
        setTimeout(() => {
          // zoom
          zoomToArea(varning.data.area);
        }, 2000);
        break;
      }
      i++;
    }
  }

}


  function changeTexts() {


    const scroll = document.getElementsByClassName("maplibregl-desktop-message")[0].innerText;

    if( scroll == 'Use ⌘ + scroll to zoom the map') {

        document.getElementsByClassName("maplibregl-desktop-message")[0].innerText = svlanguage.scrollMac;

    } else {
        document.getElementsByClassName("maplibregl-desktop-message")[0].innerText = svlanguage.scroll;
    }

    document.getElementsByClassName("maplibregl-mobile-message")[0].innerText = svlanguage.touch;

  }



  function getAreaDecription( list ) {
  let ret = "";

  for (const des of list) {
    if(des.title.code === "WHERE"){

      ret = des.text.sv;

    }
  }

  return ret;
}

function getEventDecription( list ) {
  let ret = "";

  for (const des of list) {
    if(des.title.code === "INCIDENT"){

      ret = des.text.sv;

    }
  }

  return ret;
}

function getSecondaryEventDecription( list ) {
  let ret = "";

  for (const des of list) {

    if(des.title.code === "HAPPENS"){

      ret = des.text.sv;

    }
  }

  for (const des of list) {

      if(des.title.code === "COMMENTS"){

        ret = ret + '<br/>' +des.text.sv;

      }
  }


  return ret;
}

const hideYellows = () => {

  var layers = map.getStyle().layers;

  for (var i = 0; i < layers.length; i++) {
    for (var j = 0; j < state.varningarGul.length; j++) {

      let tmp_string1 = String(layers[i].id.substring((layers[i].id).length - 4));
      let tmp_string2 = String(state.varningarGul[j].id);
   

      if ( tmp_string1  ===  tmp_string2  ) {

        if(state.hideYellowsToggle){
          map.setLayoutProperty(layers[i].id, "visibility", "none");
        } else {
          map.setLayoutProperty(layers[i].id, "visibility", "visible");
        }
        

        //console.log(state.varningarGul[j]);
        //console.log(layers[i]);

      }
    }
  }

  

  for (var i = 0; i < state.allMarkers.length; i++) {

    if(state.allMarkers[i]._element.classList[1] == 'Gul'){

      if(state.hideYellowsToggle){
        state.allMarkers[i].remove();
      } else {
        state.allMarkers[i].addTo(map);
      }

      
    }

    
  }


  state.hideYellowsToggle = !state.hideYellowsToggle;
}

    // SYNK MAPS

    function moveToMapPosition(master, clones) {
    var center = master.getCenter();
    var zoom = master.getZoom();
    var bearing = master.getBearing();
    var pitch = master.getPitch();

    clones.forEach(function (clone) {
      clone.jumpTo({
        center: center,
        zoom: zoom,
        bearing: bearing,
        pitch: pitch,
      });
    });
  }

  // Sync movements of two maps.
  //
  // All interactions that result in movement end up firing
  // a "move" event. The trick here, though, is to
  // ensure that movements don't cycle from one map
  // to the other and back again, because such a cycle
  // - could cause an infinite loop
  // - prematurely halts prolonged movements like
  //   double-click zooming, box-zooming, and flying
  function syncMaps() {
    var maps;
    var argLen = arguments.length;
    if (argLen === 1) {
      maps = arguments[0];
    } else {
      maps = [];
      for (var i = 0; i < argLen; i++) {
        maps.push(arguments[i]);
      }
    }

    // Create all the movement functions, because if they're created every time
    // they wouldn't be the same and couldn't be removed.
    var fns = [];
    maps.forEach(function (map, index) {
      fns[index] = sync.bind(
        null,
        map,
        maps.filter(function (o, i) {
          return i !== index;
        })
      );
    });

    function on() {
      maps.forEach(function (map, index) {
        map.on("move", fns[index]);
      });
    }

    function off() {
      maps.forEach(function (map, index) {
        map.off("move", fns[index]);
      });
    }

    // When one map moves, we turn off the movement listeners
    // on all the maps, move it, then turn the listeners on again
    function sync(master, clones) {
      off();
      moveToMapPosition(master, clones);
      on();
    }

    on();
    return function () {
      off();
      fns = [];
      maps = [];
    };
  }
  </script>
  
  <style global type="text/scss" lang="scss">


    html,
    body {
      font-size: 2.4vw;
      background-color: transparent;
      max-width: 560px;
    }

    body {
      margin: 0;
      padding: 0;
      line-height: 1.4;
      font-family: DNSansVF,Georgia,"Times New Roman",Times,serif;
      font-weight: 400;
      font-style: normal;
      font-stretch: normal;
    }


main {
    background-color: transparent;
    max-width: 1200px;
    position: relative;
    margin: 0 auto;
    transition: all 0.9s ease-in-out;
    box-sizing: border-box;
  }



@media screen and (min-width: 560px) {
  .standard-title {
    max-width: 560px;
    margin: 0 auto 5px;
  }
  .standard-ingress {
    max-width: 560px;
    margin: 0 auto 5px;
  }

  .standard-source {
    max-width: 560px;
    margin: 0 auto 5px;

  }
}

@media screen and (min-width: 640px) {
  .main__full-width {
    margin: 0 auto;
  }
}


.app {
    position: relative;
    width:100%;
    z-index: 10;
    color:#222;

  }
.appWrapper {
  position: relative;
  width:100%;

  }
  .mapContainer {
    position: relative;
    width:100%;
    height: 0px;
    padding-top:120%;
    margin:0px;
    z-index: 10;

    }
    .mapWrapper {
    position: absolute;
    width: 100%;
    height: 100%;
    overflow: hidden;
    top: 0;
    left: 0;

    }

	.map { position: absolute; top: 0; bottom: 0; width: 100%; }

  .marker{

    border-radius: 50%;
    display: flex; 
    flex-direction: row;
    justify-content: center;
    align-items: center;
    align-content: center;
    background-color: #ffe600;
    border: 1px solid #000;

  }

  .marker.YELLOW {
    background-color: #ffe600;
    border: 1px solid #000;
  }

  .marker.RED {
    background-color: #da000d;
    border: 1px solid #000;
  }

  .marker.ORANGE {
    background-color: #f58e04;
    border: 1px solid #000;
  }

  .marker.MESSAGE {
    background-color: #ffffff;
    border: 1px solid #ccc;
  }

  .waringText {

    padding:10px;
    padding-left: 0;
  }

  .expicon {
  position: absolute;
  width: 17px;
  height: 17px;
  fill: rgb(0, 0, 0);
  margin-top: 1px;
  right: 0;
  top: 0;
}

.warningLevel{font-weight: 800;}
.eventDescription{font-weight: 800;}
.areaName{font-weight: 400;padding-left: 28px;padding-top: 5px; display: inline-block;}

.descriptions{
  padding-top: 5px;
  display: inline-block;
  padding-left: 28px;
}


.when{
  padding-top: 5px;
  display: inline-block;
  padding-left: 28px;
}
.timestamp{
  padding-top: 5px;
  display: inline-block;
  padding-left: 28px;
  color:#a4a4a4;
}





.warningIdx {
  border-radius: 50%;
  background-color: yellow;
  height: 16px;
  width: 16px;
  position: absolute;
  left:0;
  top:0;
}
.warningIdxText {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  align-content: center;
  position: relative;
  width: 100%;
  height: 100%;
  font-size: 1.3rem;
}

.warningText { 
  position:relative;
  width:100%;
}

.warningText.YELLOW .warningIdx {
    background-color: #ffe600;
    border: 1px solid #000;
  }

.warningText.RED .warningIdx {
    background-color: #da000d;
    border: 1px solid #000;
  }

.warningText.ORANGE .warningIdx {
    background-color: #f58e04;
    border: 1px solid #000;
  }


.warningText.MESSAGE .warningIdx {
    background-color: #ffffff;
    border: 1px solid #ccc;
  }




.warningWrapper {
  background-color: #f2f2f2;
  padding: 5px;
  margin: 10px;
  margin-left: 0;
  margin-right: 0;
  font-size: 1.5rem;
  cursor: pointer;
}



.warningWrapper .when {
  display:inline-block;
}

.warningWrapper .timestamp {
  display:none;
}

.warningWrapper .firstDescriptionn {
  display:inline-block;
}

.warningWrapper .secondaryDescription {
  display:none;
}

.warningWrapper .areaDescription {
  display:none;
}

.warningWrapper .expicon {
  display:none;
}

.warningWrapper .opensvg {
  display:block;
}



.warningWrapper.showAll .when {
  display:inline-block;
}

.warningWrapper.showAll .timestamp {
  display:inline-block;
}

.warningWrapper .firstDescriptionn {
  display:inline-block;
}

.warningWrapper.showAll .secondaryDescription {
  display:inline-block;
}

.warningWrapper.showAll .areaDescription {
  display:inline-block;
}


.warningWrapper.showAll .expicon {
  display:block;
}

.warningWrapper.showAll .opensvg {
  display:none;
}

.warningHeader {
  position: relative;
  width: 100%;
  padding-right: 20px;
  padding-left: 28px;
  box-sizing: border-box;
}

.legend {
 
  background-color: transparent;
  position: absolute;
  width: 100%;
  box-sizing: border-box;
  padding: 5px;
  padding-top: 0px;
  top: 0px;
  left: 0px;
  z-index: 100;
  padding-right: 30px;
  padding-top: 7px;
  cursor: pointer;
}

.legend.showAll { 
  background-color: #f2f2f2;
}

.legendWrapper {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  align-content: flex-start;
  column-gap: 2px;
  position: relative;
  width: 100%;
  box-sizing: border-box;
  row-gap: 0.6rem;
  column-gap: 0.6rem;
  font-size: 1.5rem;
  display: none;
}

.legend.showAll .legendWrapper {

  display:flex;

}

.legend .expicon {
  display:none;
  position: static;
}

.legend .opensvg {
  display:block;
  position: static;
}



.legend.showAll .expicon {
  display:block;
  position: static;
  margin-top: 0px;
}

.legend.showAll .opensvg {
  display:none;
  position: static;
  margin-top: 0px;
}

.openwrapper {
  background-color: #f2f2f2;
  position: absolute;
  right: 5px;
  top: 5px;
  width: 25px;
  height: 25px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  align-content: center;
  border-radius: 50%;
  border:1px solid #000;
}

.legend.showAll .openwrapper  {

    border:1px solid #f2f2f2;
    right: 0px;
    top: 5px;
}

.legendbox {

  display:flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  align-content: flex-start;
  position: relative;
  width: 100%;
  box-sizing: border-box;
  font-size: 1.2rem;
 

}
.legendheader{
  background-color: #ffe600;
  color:#000;
  width: 100%;
  position: relative;
  font-weight: 600;
  padding-left: 3px;
  box-sizing: border-box;
  border:1px solid #000;
}

.legendtext {
  font-size: 1.2rem;
  line-height: 1.2;
  padding-top: 0.5rem;

}



.chunkingWrapper {
  background-color: #f2f2f2;
  padding: 5px;
  margin: 10px;
  margin-left: 0;
  margin-right: 0;
  font-size: 1.5rem;
  cursor: pointer;
  padding-top:12px;
  padding-bottom: 12px;
  position: relative;
  width: 100%;
  box-sizing: border-box;

}

.BAR-YELLOW {
    background-color: #ffe600;
  }

  .BAR-RED {
    background-color: #da000d;
  }

  .BAR-ORANGE {
    background-color:  #f58e04;
  }
  .BAR-MESSAGE {
    background-color:   #ccc;
  }

.chunkingText { 
  position:relative;
  width:100%;
}



.chunkingWrapper .expicon {
  display:none;
}

.chunkingWrapper .opensvg {
  display:block;
}

.chunkingWrapper.showAll .expicon {
  display:block;
}

.chunkingWrapper.showAll .opensvg {
  display:none;
}



.printTimeBox {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 99;
  min-width: 40px;
  padding: 5px;
  font-size: 12px;
  background-color: #f2f2f2;
  box-sizing: border-box;
}

.printTime {
  position: relative;
}

.divider {
  position: relative;
  width: 100%;
  height: 10px;
}


.debugg {

    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    align-content: center;
    height: 500px;
    
}
.debuggWrapper {font-size: 20px;}

.hide_me {
    display: none;
}


.expandertext { 
  text-align: right;
  position: absolute;
  top: 0px;
  right: 25px;
  pointer-events: none;
  display:block;
}
.showAll .expandertext { display:none}

@media screen and (min-width: 420px) {
  html,body {
      font-size: 10px;
    }
  }


.mapfront .maplibregl-canvas {
  mix-blend-mode: multiply;
  cursor: pointer !important;
}

.clickArea {
  position:absolute;
  top: 0;
  right: 0;
  height: 50px;
  width: 80px;

}
  </style>


<svg xmlns="http://www.w3.org/2000/svg" style="display: none;">
 
    <symbol viewBox="0 0 24 24"  id="opensvg" >
        <polygon transform="translate(12.000000, 12.499990) rotate(-90.000000) translate(-12.000000, -12.499990) " points="16.4999898 2.49998976 6.49998976 12.5015898 16.4999898 22.4999898 17.5000102 21.4999898 8.49998976 12.5015898 17.5000102 3.49998976"></polygon>
    </symbol>
    
    <symbol viewBox="0 0 24 24"  id="closesvg" >
                <polygon  transform="translate(12.000000, 11.500000) rotate(-270.000000) translate(-12.000000, -11.500000) " points="6.5 11.5 16.5 21.5 17.5 20.5 8.5 11.5 17.5 2.5 16.5 1.5"></polygon>
    </symbol>
      
    <symbol viewBox="0 0 24 24" id="closeXsvg">
      <polygon points="20.0000 3.00000 12 11.00000 4.0001 3.00000 3.9999 3.00000 3 4.00000 11 12.00000 3 20.00000 4 21.00000 12 13.00000 20 21.00000 21 20.00000 13 12.00000 21 4.00000 20.0001 3.00000"></polygon>
    </symbol>

</svg>



  <main
  class={`main__content-wrapper ${handleMargins() ? "main__padded-width" : "main__normal-width"} ${myRenderDarkMode ? "main__dark-mode" : "main__light-mode"} ${myRenderForcedColorMode ? "main__padded-top-bottom" : ""} ${handleMargins() ? 'main__full-width' : ''}`}
  >


{#if haveADate}
        {#if state.header}
        <div class={`standard-title`}>
            {state.header}
        </div>
        {/if}
        {#if state.introduction}
        <div class="standard-ingress">
            {@html state.introduction}
        </div>
        {/if}
        <div class="app">
            <div class="appWrapper">    

            <div class={`legend ${state.showContent == 'Bara meddelanden' ? 'hide_me' : ''}`} class:showAll="{legendOnOff}" on:click="{() => legendOnOff = !legendOnOff}" on:keydown="{() => legendOnOff = !legendOnOff}">
                <div class="openwrapper">
                <svg class="expicon"><use xlink:href='#closesvg'/></svg>
                <svg class="expicon opensvg"><use xlink:href='#opensvg'/></svg>
            </div>
            
            <div class="legendWrapper">  

              <div class={`legendbox ${state.showContent == 'Bara varningar' ? 'hide_me' : ''}`}>
                <div class='legendheader MESS' style={`background-color:${mapcolors['Meddelande'].area};border-color:${mapcolors['Meddelande'].line}`}>Meddelande</div>
                <div class="legendtext">Meddelanden angående brandrisk, höga temperaturer eller risk för vattenbrist.</div>
                </div>

                <div class="legendbox">
                <div class="legendheader YELLOW" style={`background-color:${mapcolors['Gul'].area};border-color:${mapcolors['Gul'].line}`}>Gul varning</div>
                <div class="legendtext">Konsekvenser för samhället, vissa risker för allmänheten.</div>
                </div>

                <div class="legendbox">
                <div class="legendheader ORANGE" style={`background-color:${mapcolors['Orange'].area};border-color:${mapcolors['Orange'].line}`}>Orange varning</div>
                <div class="legendtext">Allvarliga konsekvenser för samhället, fara för allmänheten.</div>
                </div>

                <div class="legendbox">
                <div class="legendheader RED" style={`background-color:${mapcolors['Röd'].area};border-color:${mapcolors['Röd'].line}`}>Röd varning</div>
                <div class="legendtext">Mycket allvarliga konsekvenser för samhället, stor fara för allmänheten.</div>
                </div>

            </div>
            </div>
            <div class="printTimeBox"><div class="printTime">{state.printtime}</div></div>
              <div class="mapContainer">
                  <div class="mapWrapper">
                  <div class="map " id="mapBG" bind:this={mapContainerBG}></div>
                  </div>
                  <div class="mapWrapper">
                  <div class="map mapfront" id="map" bind:this={mapContainer}></div>
                  </div>
              </div>
            
                {#each  state.varningarText as varning,index}

                {#if  state.chunkingListStart[index] == 's'}
                <div class="chunkingWrapper BAR-{varning.data.warningLevel.code}" class:showAll="{!onOffChunking['chunking'+index]}" >
                  <div class="chunkingText"> { state.chunking[state.chunkingtrans[varning.data.warningLevel.code].text].text} - {state.chunking[state.chunkingtrans[varning.data.warningLevel.code].text].antal} stycken.
                    <div class="expandertext">Visa alla</div>  
                    <svg class="expicon"><use xlink:href='#closesvg'/></svg>
                      <svg class="expicon opensvg"><use xlink:href='#opensvg'/></svg>
                  </div>
                  <div class="clickArea" on:click|self="{ () => { onOffChunking['chunking'+index] = !onOffChunking['chunking'+index]; showChunks(onOffChunking['chunking'+index],varning.data.warningLevel.code); } }"></div>
                  {#if  varning.data.warningLevel.code == 'YELLOW'}
                  <div style="margin-top:8px;"></div>
                  <Switch {hideYellows}  label="Visa i karta" design="slider" fontSize={1.4} uniqNumber={55} value={'on'};/>
                  {/if}

                </div>      
                {/if}



                <div style={`display:${state.chunking[state.chunkingtrans[varning.data.warningLevel.code].text].chunk == true ? 'none' : 'block'}`} class="warningWrapper   CH-{varning.data.warningLevel.code} " class:showAll="{onOff['warning'+index]}" on:click="{ () => { onOff['warning'+index] = !onOff['warning'+index];  setTimeout(() => { zoomToArea(varning.data.area); }, "1000");} }" on:keydown="{ () => { onOff['warning'+index] = !onOff['warning'+index];  setTimeout(() => { zoomToArea(varning.data.area); }, "1000");} }">
                <div class="warningText {varning.data.warningLevel.code} ">
                    
                    <svg class="expicon"><use xlink:href='#closesvg'/></svg>
                    <svg class="expicon opensvg"><use xlink:href='#opensvg'/></svg>
                    
                    <span class='warningIdx' style={`background-color:${mapcolors[varning.data.warningLevel.sv].area};border-color:${mapcolors[varning.data.warningLevel.sv].line}`}><span class='warningIdxText'>{index+1}</span></span>
                    <div class="warningHeader">  
                      <span class='warningLevel'>{varning.wmess}</span> – <span class='eventDescription'>{varning.data.eventDescription.sv}</span>
                    </div>
                    <span class='areaName'>{varning.data.areaName.sv}</span>
                    <br><span class='descriptions firstDescription'>{getEventDecription(varning.data.descriptions)}</span>
                    {#if  getSecondaryEventDecription(varning.data.descriptions) != ''}<span class='descriptions secondaryDescription'>{@html getSecondaryEventDecription(varning.data.descriptions)}</span>{/if}
                    <span class='descriptions areaDescription'>Var: {@html getAreaDecription(varning.data.descriptions)}</span>
                    <br><span class="when">Gällande: {varning.sdate} – {varning.edate}</span>
                    <br><span class="timestamp">Utfärdad: {varning.udate}</span>
                </div>
                </div>

                {/each}
            
            </div>
        </div>
        {#if state.source}
        <div class="standard-source">
            {@html state.source}<br>
            Läs mer på <a href="https://www.smhi.se/vader/varningar-och-brandrisk/varningar-och-meddelanden/varningar"> SMHI</a> 's egen sida för varningar och meddelanden.
        </div>
        {/if}


{:else}
<div class="debugg"><div class="debuggWrapper">Ange ett datum</div></div>
{/if}


</main>